const StoreSettingType = {
  ALL: 'ALL',
  AUTO_ACCEPT: 'AUTO_ACCEPT',
  AUTO_TAKE: 'AUTO_TAKE',
  TUESDAY: 'TUESDAY',
};

export default StoreSettingType;
